'use client'

import { useHeaderHeight } from 'hooks/useHeaderHeight/useHeaderHeight'
import { FiltersButton } from 'product-list/components/Filters/FiltersButton/FiltersButton'
import { Views } from 'product-list/components/Views/Views'
import type { View } from 'product-list/types/View'
import { cx } from 'utils/cx'
import styles from './Sticky.module.scss'

interface StickyProps {
	readonly displayViewSelector: boolean
	readonly displayFilters: boolean
	readonly onUserViewSelect?: (view: View) => void
}

export function Sticky({
	displayFilters,
	displayViewSelector,
	onUserViewSelect,
}: StickyProps) {
	const { headerHeight } = useHeaderHeight()

	if (!(displayFilters || displayViewSelector)) {
		return null
	}

	return (
		<div style={{ top: `${headerHeight}px` }} className={styles.sticky}>
			<div
				className={cx(
					styles.inner,
					!displayFilters && displayViewSelector && styles.onlyViewSelector
				)}
			>
				{displayFilters && <FiltersButton />}
				{displayViewSelector && <Views onUserViewSelect={onUserViewSelect} />}
			</div>
		</div>
	)
}
